const LOCAL_E2E_HOSTS = new Set(['127.0.0.1', 'localhost'])

const isLocalE2E = () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (!LOCAL_E2E_HOSTS.has(window.location.hostname)) {
    return false
  }

  return new URLSearchParams(window.location.search).get('__e2e_authenticated') === '1'
}

export {
  isLocalE2E
}
